/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityRefreshResponse
 */
export interface MonitEntityRefreshResponse {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityRefreshResponse
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityRefreshResponse
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityRefreshResponse
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityRefreshResponse
     */
    process_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityRefreshResponse
     */
    external_id?: string;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityRefreshResponse
     */
    history_index?: number;
}

/**
 * Check if a given object implements the MonitEntityRefreshResponse interface.
 */
export function instanceOfMonitEntityRefreshResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityRefreshResponseFromJSON(json: any): MonitEntityRefreshResponse {
    return MonitEntityRefreshResponseFromJSONTyped(json, false);
}

export function MonitEntityRefreshResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityRefreshResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'process_id': !exists(json, 'process_id') ? undefined : json['process_id'],
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
        'history_index': !exists(json, 'history_index') ? undefined : json['history_index'],
    };
}

export function MonitEntityRefreshResponseToJSON(value?: MonitEntityRefreshResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_domain': value.entity_domain,
        'type': value.type,
        'process_id': value.process_id,
        'external_id': value.external_id,
        'history_index': value.history_index,
    };
}

